import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Form, Input, Label, Segment, Select, Tab } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

interface Props {
  selectedElementDat: any;
  commScheme: any;
}

function CsCardBox({ selectedElementDat, commScheme }: Props) {
  const {
    CommunicationStore,
    RolesAndPermissionsStore,
    ApiStore: { templateMetadataElement },
  } = useStore();
  const { rolesRegistry, loadRoles, rolesByName } = RolesAndPermissionsStore;
  const { communicationInput } = CommunicationStore;

  ///Draggable function
  const addClass = (elem: any, className: any) => {
    const classNames = elem.className.split(' ');
    if (classNames.indexOf(className) === -1) {
      classNames.push(className);
    }
    elem.className = classNames.join(' ');
  };

  // const selectElem = ( selector:any ) => {
  //   return document.querySelector( selector )
  // }

  const selectAllElems = (selector: any) => {
    return document.querySelectorAll(selector);
  };

  // const removeElem = ( elem:any ) => {
  //   return elem ? elem.parentNode.removeChild( elem ) : false
  // }

  const nativeBindDraggable = (elems: any = false) => {
    elems = elems || selectAllElems('.native_drag');
    if (!elems) {
      // No element exists, abort
      return false;
    } else if (elems.outerHTML) {
      // if only a single element, put in array
      elems = [elems];
    }
    // else it is html-collection already (as good as array)

    for (let i = 0; i < elems.length; i++) {
      // For every elem in list, attach or re-attach event handling
      elems[i].dataset.transferreference = `transit_${new Date().getTime()}`;
      elems[i].ondragstart = function (e: any) {
        // if (!e.target.id){
        //   e.target.id = (new Date()).getTime();
        // }
        const globalWin: any = window;
        globalWin.inTransferMarkup = e.target.outerHTML;
        globalWin.transferreference = elems[i].dataset.transferreference;
        // updateMsg(e.target.outerHTML)
        addClass(e.target, 'dragged');
      };
    }
  };

  const nativeBindWriteRegion = (elems: any = false) => {
    elems = elems || selectAllElems('.native_receiver');
    if (!elems) {
      // No element exists, abort
      return false;
    } else if (elems.outerHTML) {
      // if only a single element, put in array
      elems = [elems];
    }
    // else it is html-collection

    for (let i = 0; i < elems.length; i++) {
      elems[i].ondragover = function (e: any) {
        e.preventDefault();
        return false;
      };
      elems[i].ondrop = function (e: any) {
        receiveBlock(e);
      };
    }
  };

  const receiveBlock = (e: any) => {
    e.preventDefault();
    const globalWin: any = window;
    const content = globalWin.inTransferMarkup;

    globalWin.inTransferMarkup = '';

    let range = null;
    if (document.caretRangeFromPoint) {
      // Chrome
      range = document.caretRangeFromPoint(e.clientX, e.clientY);
    } else if (e.rangeParent) {
      // Firefox
      range = document.createRange();
      range.setStart(e.rangeParent, e.rangeOffset);
    }
    const sel: any = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    e.target.focus();

    document.execCommand('insertHTML', false, content);
    sel.removeAllRanges();

    // reset draggable on all blocks, esp the recently created
    nativeBindDraggable(
      document.querySelector(
        `[data-transferreference='${globalWin.transferreference}']`,
      ),
    );
    // removeElem( selectElem( '.dragged' ) );
    updateMsg('dragData');
    updateSub('dragData');
    return false;
  };

  useEffect(() => {
    nativeBindDraggable();
    nativeBindWriteRegion();
    // eslint-disable-next-line
  }, []);
  ////End

  useEffect(() => {
    if (rolesRegistry.size <= 1) loadRoles();
  }, [rolesRegistry.size, loadRoles]);

  const attachInput = (e: string) => {
    communicationInput.getCommunicationInitScheme.forEach((comData: any) => {
      if (comData.status === commScheme.status) {
        comData.attachment = e;
      }
    });
  };

  const getRoleVal = (e: any, data: any) => {
    communicationInput.getCommunicationInitScheme.forEach((comData: any) => {
      if (comData.status === commScheme.status) {
        comData.rolesId = data.value;
      }
    });
  };

  const updateMsg = (param: string) => {
    communicationInput.getCommunicationInitScheme.forEach((data: any) => {
      if (data.status === commScheme.status) {
        const currentMsg: any =
          document.getElementsByClassName('msg-communication')[0].innerHTML;
        const currentTabIndex: number = commScheme.status;
        if (param === 'dragData') {
          let arrPus: any = [];
          const tabContainer: any =
            document.querySelector('.msg-communication');
          const elementTag = tabContainer.querySelectorAll('C');
          elementTag.forEach((data: any) => {
            // eslint-disable-next-line
            arrPus.push(
              '"' +
                data.textContent.slice().replace(/ /g, '_') +
                '"' +
                ':' +
                '"' +
                data.id +
                '"',
            );
          });
          data.message = currentMsg;
          data.model = '{' + arrPus + '}';
        }
        CommunicationStore.getCommunicationMsg(currentMsg, currentTabIndex);
      }
    });
  };

  const updateSub = (param: string) => {
    communicationInput.getCommunicationInitScheme.forEach((data: any) => {
      if (data.status === commScheme.status) {
        const currentSub: any =
          document.getElementsByClassName('sub-communication')[0].innerHTML;
        const currentTabIndex: number = commScheme.status;
        if (param === 'dragData') {
          let arrPus: any = [];
          const tabContainer: any =
            document.querySelector('.sub-communication');
          const elementTag = tabContainer.querySelectorAll('C');
          elementTag.forEach((data: any) => {
            // eslint-disable-next-line
            arrPus.push(
              '"' +
                data.textContent.slice(1, -1).replace(/ /g, '_') +
                '"' +
                ':' +
                '"' +
                data.id +
                '"',
            );
          });
          data.subject = currentSub;
          data.modelSub = '{' + arrPus + '}';
        }
        CommunicationStore.getCommunicationSub(currentSub, currentTabIndex);
      }
    });
  };

  const [communicationMsgStr, setCommunicationMsgStr] = useState<any>(
    commScheme.message,
  );
  const [communicationSubStr, setCommunicationSubStr] = useState<any>(
    commScheme.subject,
  );

  useEffect(() => {
    setCommunicationMsgStr(commScheme.message);
  }, [commScheme.message]);

  useEffect(() => {
    setCommunicationSubStr(commScheme.subject);
  }, [commScheme.subject]);

  const optionList = () => {
    return rolesByName.map((data: any) => ({
      key: data.roleName,
      text: data.roleName,
      value: data.id,
    }));
  };

  const getSelectedRole = () => {
    if (commScheme !== undefined || commScheme.rolesId !== null) {
      return commScheme.rolesId;
    } else {
      return '';
    }
  };

  return (
    <Tab.Pane>
      <Segment.Group>
        <Segment compact>
          <div className="split">
            <div
              className="text msg-communication native_receiver"
              contentEditable="true"
              style={{
                height: '70vh',
                width: '70vw',
                color: 'black',
                border: '0px',
              }}
              dangerouslySetInnerHTML={{
                __html: communicationMsgStr,
              }}
              onKeyUp={() => {
                updateMsg('textData');
              }}
              suppressContentEditableWarning={true}
            ></div>
            <div className="fields">
              {/* <CsCardBox selectedElementDat={selectedElementDat} roleValueData={roleValueData}/>           */}
              <Segment>
                <Segment>
                  <Label.Group color="blue" size="medium">
                    <Label as="a" style={{ width: '100%' }}>
                      <p>Subject:</p>
                      {/* <Input style={{width: '100%'}} onChange = {(e:any) => subjectInput(e.target.value)} placeholder="Enter Your Subject" value={commScheme !== undefined? commScheme.subject: ''}/> */}
                      <div
                        contentEditable="true"
                        className="sub-communication native_receiver"
                        // placeholder="Enter the Subject..."
                        dangerouslySetInnerHTML={{
                          __html: communicationSubStr,
                        }}
                        onKeyUp={() => {
                          updateSub('textData');
                        }}
                        suppressContentEditableWarning={true}
                      ></div>
                    </Label>
                    <Label as="a" style={{ width: '100%' }}>
                      <p>User Role:</p>
                      <Form.Field
                        control={Select}
                        style={{ width: '100%' }}
                        placeholder="Select Role"
                        search
                        selection
                        options={optionList()}
                        value={getSelectedRole()}
                        onChange={(e: any, data: any) => getRoleVal(e, data)}
                      />
                    </Label>

                    <Label as="a" style={{ width: '100%' }}>
                      <p>Attachment:</p>
                      <Input
                        style={{ width: '100%' }}
                        onChange={(e: any) => attachInput(e.target.value)}
                        placeholder="Enter file format (eg: .doc, .jpg)"
                        value={
                          commScheme !== undefined
                            ? commScheme.attachment === null
                              ? ''
                              : commScheme.attachment
                            : ''
                        }
                      />
                    </Label>
                  </Label.Group>
                </Segment>

                <Segment>
                  <Label.Group color="blue" size="medium">
                    <h5>WorkFlow Components:</h5>
                    {!!selectedElementDat &&
                      selectedElementDat.map((data: any) => {
                        return (
                          <Label
                            as="c"
                            key={data.elementId}
                            className="native_drag"
                            data-type="dateselector"
                            contentEditable="false"
                            draggable="true"
                            id={data.elementId}
                          >
                            {' '}
                            {data.elementName.replace(/ /g, '_')}{' '}
                          </Label>
                        );
                      })}
                  </Label.Group>
                </Segment>
                <Segment>
                  <Label.Group color="blue" size="medium">
                    <h5>Meta Data Components:</h5>
                    {templateMetadataElement.map((a: any) => (
                      <Label
                        as="c"
                        key={a.key}
                        className="native_drag"
                        data-type="dateselector"
                        contentEditable="false"
                        suppressContentEditableWarning={false}
                        draggable="true"
                        id={a.key}
                      >
                        {a.text}
                      </Label>
                    ))}
                  </Label.Group>
                </Segment>
              </Segment>
            </div>
          </div>
        </Segment>
      </Segment.Group>
    </Tab.Pane>
  );
}

export default observer(CsCardBox);
